import React from 'react';

import Icon from '../Icon/Icon';

const AlertIcon = (props) => {
    return (
        <Icon width='24' height='24' fill='none' {...props}>
            <g clipPath='url(#clip0_9705_25332)'>
                <mask id='mask0_9705_25332' maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
                    <path d='M24 0H0V24H24V0Z' fill='white' />
                </mask>
                <g mask='url(#mask0_9705_25332)'>
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M11.9712 6.20862C13.5997 6.20862 15.0767 6.87159 16.1619 7.94671C17.2548 9.02952 17.9509 10.5298 18.0089 12.1964L18.0123 17.7086H5.92969V12.4352C5.98907 10.664 6.67653 9.10812 7.76389 7.99311C8.84991 6.87946 10.334 6.20862 11.9712 6.20862Z'
                        stroke='#393E44'
                        strokeWidth='1.5'
                    />
                    <path d='M4.50195 17.7086H19.502' stroke='#393E44' strokeWidth='1.5' strokeLinecap='round' />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M13.931 17.7088C13.9371 18.4088 13.717 18.9004 13.3611 19.2563C13.0052 19.6122 12.5136 19.8323 11.9705 19.8323C11.4275 19.8323 10.9358 19.6122 10.5799 19.2563C10.224 18.9004 10.0039 18.4088 10.0039 17.8657L13.931 17.7088Z'
                        stroke='#393E44'
                        strokeWidth='1.5'
                    />
                    <path
                        d='M10.3867 4.12841C10.915 4.01521 11.4432 3.95862 11.9714 3.95862C12.4996 3.95862 13.0279 4.01521 13.5561 4.12841'
                        stroke='#393E44'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                    />
                </g>
            </g>
            <defs>
                <clipPath id='clip0_9705_25332'>
                    <rect width='24' height='24' fill='white' />
                </clipPath>
            </defs>
        </Icon>
    );
};

export default AlertIcon;
